<template>
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-color-qrcode`]" width="1em" height="1em" v-bind="$attrs"><rect x="3.43" y="3.43" width="7.217" height="7.217" rx="2" stroke="#165DFF" stroke-width="1.66"/><rect x="3.43" y="13.352" width="7.217" height="7.217" rx="2" stroke="#165DFF" stroke-width="1.66"/><rect x="13.353" y="3.43" width="7.217" height="7.217" rx="2" stroke="#165DFF" stroke-width="1.66"/><path d="M13.3532 13.3516L20.5701 13.3516M14.2553 16.3047V20.5732M16.9616 16.3047V20.5732M19.6679 16.3047V20.5732" stroke="#00BBD8" stroke-width="1.66" stroke-linecap="round" stroke-linejoin="round"/></svg>
</template>
<script>

export default {
  name: 'IconColorQrcode',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
